import { useCallback, useEffect, useState } from "react";

import { DecisionTree } from "../../types/api/decision-tree";
import { get, set } from "idb-keyval";
import "./DecisionTree.css";
import { StyledCircularProgress } from "../../components/Loader";
import TreeQuestionnaire from "../../components/decision-tree/TreeQuestionnaire";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../utils/api/axios";
import { AxiosError } from "axios";
import { useAppDispatch } from "../../store/hook";
import { setHasNoNetwork } from "../../store/reducers/auth.slice";

const DecisionTreePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [decisionTree, setDecisionTree] = useState<DecisionTree>();

  const dispatch = useAppDispatch();
  const fetchDataOffline = useCallback(async () => {
    const decisionTrees = await get<DecisionTree[]>("decision-trees");
    if (!decisionTrees) return false;
    if (!id) return false;
    const tree = decisionTrees.find((tree) => tree.id === Number.parseInt(id));
    if (!tree) return false;
    setDecisionTree(tree);
    return true;
  }, [id, setDecisionTree]);

  const saveDecisionTrees = useCallback(
    async (decisionTrees: DecisionTree[]) => {
      await set("decision-trees", decisionTrees);
    },
    []
  );

  const fetchDataOnline = useCallback(async () => {
    const { data } = await api.get<DecisionTree[]>(`/decision-trees/list`);
    saveDecisionTrees(data);
    if (!id) return false;
    const tree = data.find((tree) => tree.id === Number.parseInt(id));
    if (!tree) return false;
    setDecisionTree(tree);
    return true;
  }, [saveDecisionTrees, id, setDecisionTree]);

  const fetchData = useCallback(async () => {
    const offlineSuccess = await fetchDataOffline();
    try {
      const onlineSuccess = await fetchDataOnline();
      return offlineSuccess || onlineSuccess;
    } catch (e) {
      if (e instanceof AxiosError) {
        if (e.status === 500) dispatch(setHasNoNetwork(true));
      }
      return offlineSuccess || false;
    }
  }, [dispatch, fetchDataOffline, fetchDataOnline]);

  useEffect(() => {
    const success = fetchData();
    if (!success) {
      navigate("/aide-administration");
    }
  }, [fetchData, navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="decison-tree-container">
      <div className="decision-tree-title-container">
        <h1
          className="decision-tree-title-category"
          onClick={() => navigate("/aide-administration")}
        >
          Aide à la prescription des antibiotiques
        </h1>
        <h1 className="decision-tree-title-separator">/</h1>
        {decisionTree?.name && (
          <h1 className="decision-tree-title-name">{decisionTree.name}</h1>
        )}
      </div>

      {!decisionTree ? (
        <StyledCircularProgress size={24} />
      ) : (
        <TreeQuestionnaire decisionTree={decisionTree} />
      )}
    </div>
  );
};

export default DecisionTreePage;
